export const eventData = [
  {
    id: 1,
    name: "TES: The Entrepreneur Show 2023",
    imgurl:`https://res.cloudinary.com/dj9kcydeo/image/upload/v1683370906/eventcardImg/Tes_sandeepjain.jpg`,
  },
  {
    id: 2,
    name: "E-Summit 2022",
    imgurl:`https://res.cloudinary.com/dj9kcydeo/image/upload/v1683371589/eventcardImg/esummit%202022.jpg`,
  },
  {
    id: 3,
    name: `Indian Navy Visit`,
    imgurl:`https://res.cloudinary.com/dj9kcydeo/image/upload/v1683370853/eventcardImg/indiannavivisit.jpg`,
  },

  {
    id: 4,
    name: `Achiever's Talk`,
    imgurl:`https://res.cloudinary.com/dj9kcydeo/image/upload/v1683371584/eventcardImg/achievers_talk.jpg`,
  },
  {
    id: 5,
    name: "Smart India Hackathon",
    imgurl:`https://res.cloudinary.com/dj9kcydeo/image/upload/v1683371586/eventcardImg/SIH.jpg`
  },

  {
    id: 6,
    name: "Game of Drone",
    imgurl:`https://res.cloudinary.com/dj9kcydeo/image/upload/v1683371588/eventcardImg/game_of_drone.png`
  },
  {
    id: 7,
    name: "TES: The Entrepreneur Show 2022",
    imgurl:`https://res.cloudinary.com/dj9kcydeo/image/upload/v1683371588/eventcardImg/Tes_old.jpg`,
  },
];
